import { render, staticRenderFns } from "./FileHistoryList.vue?vue&type=template&id=9377c5a2&"
import script from "./FileHistoryList.vue?vue&type=script&lang=js&"
export * from "./FileHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./FileHistoryList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports